// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xn_O","col":"styles_col__jaxqt"};